import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Section } from '@radix-ui/themes';
import { selectDevice } from 'store/slices/common';

import Visual from 'components/common/visual';
import Breadcrumbs from 'components/common/breadcrumbs';
import PageTitle from 'components/layout/pageTitle';
import BoardDetail from 'components/board/boardDetail';

// 홍보자료 > 홍보자료 상세 페이지
export default function PromotionDetail() {
  const pageName = '홍보자료';
  const boardType = 'promotion';

  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  return (
    <>
      <Visual category={boardType} title={pageName} />
      <Breadcrumbs />
      <Section p="0" pb={isMobile ? 'var(--space-18)' : 'var(--space-35)'} className={boardType}>
        <Container size={isMobile ? '1' : '4'}>
          <PageTitle icon="star" title={pageName} />
          <BoardDetail boardType={boardType} />
        </Container>
      </Section>
    </>
  );
}
